import React from 'react'
import ContentLoader from 'react-content-loader'

const GridLoader = props => (
  <ContentLoader
    width={"auto"}
    height={"auto"}
    viewBox="0 0 800 500"
    backgroundColor="#eaeced"
    foregroundColor="#ffffff"
    {...props}
  >
    <rect x="10" y="10" rx="5" ry="5" width="260" height="140" />
    <rect x="280" y="10" rx="5" ry="5" width="260" height="280" />
    <rect x="550" y="10" rx="5" ry="5" width="260" height="140" />
    <rect x="10" y="160" rx="5" ry="5" width="260" height="280" />
    <rect x="280" y="300" rx="5" ry="5" width="260" height="140" />
    <rect x="550" y="160" rx="5" ry="5" width="260" height="280" />
  </ContentLoader>
)

export default GridLoader
